
export default {
	PARAMETERS: "parameters",
	CRITERIONS: "criterions",
	CONDITIONS: "conditions",
	ITEM_PARAMETERS: "itemParameters"
}